import { Icon } from '@design/components/icon/Icon';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import { Suggestion } from '../../hooks/use-recent-searches/useRecentSearches';
import styles from './SearchSuggestions.module.scss';

export interface SearchSuggestionsProps {
  list: Suggestion[];
  handleSelect: (item: Suggestion) => void;
}

export const SearchSuggestions = ({
  list,
  handleSelect,
}: SearchSuggestionsProps) => {
  const { t } = useTranslation('news');

  return (
    <div
      className={styles.searchSuggestionsRoot}
      data-testid="search-suggestions"
    >
      {list.map((suggestion, index, array) => {
        const prevSuggestion = array[index - 1];
        const showGroupLabel =
          !prevSuggestion || prevSuggestion.type !== suggestion.type;

        return (
          <Fragment key={`${suggestion.type}-${suggestion.label}`}>
            {showGroupLabel && (
              <h2 className={styles.categoryTitle}>
                {
                  /* i18next-extract-mark-context-next-line ["recent_searches", "topics", "industry", "asset_class"] */
                  t('news:suggestion.type', { context: suggestion.type })
                }
              </h2>
            )}
            <button
              className={styles.keywordButton}
              type="button"
              onClick={() => {
                handleSelect(suggestion);
              }}
            >
              <span className={styles.label}>{suggestion.label}</span>
              <Icon iconName="Search" size={16} />
            </button>
          </Fragment>
        );
      })}
    </div>
  );
};
